import { AuerState } from "@auer-steel/Store/AuerState";
import updateRmaForm from "@auer-steel/Store/Pages/RequestRma/Handlers/UpdateRmaForm";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { RequestRmaPageContext } from "@insite/content-library/Pages/RequestRmaPage";
import Select from "@insite/mobius/Select";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: AuerState) => {
    return {
        rmaFormState: state.auerRequestRma.formState,
    };
};

const mapDispatchToProps = {
    updateRmaForm,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const Input: FC<Props> = props => {
    if (props.rmaFormState.isWarrantyClaim) {
        return null;
    }

    const { value: order } = useContext(OrderStateContext);
    let reasonCodes: string[] = [];
    if (order?.properties["p21RmaReasonCode"]) {
        reasonCodes = JSON.parse(order?.properties["p21RmaReasonCode"]);
    }
    const valueChanged = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        props.updateRmaForm({
            ...props.rmaFormState,
            rmaReason: value,
        });
        
    };
    return (
        <StyledWrapper
        css={css`
            margin-bottom: 20px;
            max-width: 350px;
            @media(max-width: 767px) {
                max-width: 100%;
            }
        `}>
            <Select
                label={translate("Reason for return")}
                required
                placeholder="Select Reason"
                onChange={valueChanged}
                value={props.rmaFormState.rmaReason}
                
            >
                <option key="null" value="" />
                {reasonCodes.map(code => (
                    <option key={code} value={code}>
                        {code}
                    </option>
                ))}
            </Select>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(Input),
    definition: {
        allowedContexts: [RequestRmaPageContext],
        group: "Return Request (RMA)",
        displayName: "RMA Reason",
    },
};

export default widgetModule;
